export default "__VITE_ASSET__mfpjJnw8__"